import "./style.css";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AuthService from "./services/auth.js";
import { initSocket } from "./services/socket.js";
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import nl from "./locales/nl.json";
import Sonner from "vue-sonner";

// Vue i18n setup
const i18n = createI18n({
  legacy: false, // Gebruik Composition API mode
  locale: "nl", // standaard Nederlands
  fallbackLocale: "en",
  messages: { en, nl },
});

// Initialize authentication on app startup
const initializeApp = async () => {
  try {
    // Initialize auth service
    await AuthService.initialize();

    // Initialize Socket.IO if user is authenticated
    const token = localStorage.getItem("authToken");
    const backendUrl =
      import.meta.env.VITE_BACKEND_URL ||
      "https://netnest-internal-platform-backend-2dow.onrender.com";

    if (token) {
      initSocket(backendUrl, token);
    }
  } catch (error) {
    console.error("App initialization failed:", error);
  }

  // Create and mount Vue app
  createApp(App).use(router).use(i18n).use(Sonner).mount("#app");
};

// Start app
initializeApp();
